import getProp from '@f/get-prop'

export const isRequestingChargeById = (state, chargeId) =>
  getProp(`receipt.${chargeId}.isRequesting`, state) || false

export const didFailToRequestChargeById = (state, chargeId) =>
  getProp(`receipt.${chargeId}.didRequestFail`, state) || false

export const getChargeById = (state, chargeId) =>
  getProp(`receipt.${chargeId}.data`, state)

export const didRequestChargeById = (state, chargeId) =>
  getProp(`receipt.${chargeId}.didRequest`, state) || false



// WEBPACK FOOTER //
// ./selectors/receipt.js